import React, {useContext, useEffect, useState} from 'react';
import {
    Box,
    Button,
    Grid,
    FormControl,
    Input,
    InputLabel,
    useToastProvider,
    FormHelperText
} from '@deere/fuel-react';
import {useAuthConfig} from "../shared/helper";
import {FormSelect} from "../shared/FormSelect";
import {Controller, useForm} from "react-hook-form";
import {ModalDialog} from "../shared/ModalDialog";
import {ReasonsContext} from './Ratings';

export const RatingNotApplicable = ({
                                        criteriaId,
                                        suppliers,
                                        criteria,
                                        isEdit = false,
                                        onNotApplicableAction
                                    }) => {

    const {enqueueToast} = useToastProvider();
    let authAxios = useAuthConfig();
    const [reasonsList, setReasonsList] = useState([]);
    const [reasonValue, setReasonValue] = useState("");
    const [comment, setComment] = useState("");
    const [error, setError] = useState("");
    const {control} = useForm();
    const reasons = useContext(ReasonsContext);

    const onCancel = () => {
        onNotApplicableAction("", "cancel")
    }

    const onDelete = () => {
        authAxios.delete(`/ratingNA/${criteria.notApplicableReason.id}`)
            .then(res => {
                onNotApplicableAction(res, "delete")
                enqueueToast({
                    variant: "success",
                    title: "Deleted Successfully",
                    isCloseable: true
                });
            }).catch((error) => {
            enqueueToast({
                variant: "error",
                title: "System Error",
                isPersistent: true
            });
            console.log(error);
        });
    }

    const onSubmit = () => {
        if (criteria.notApplicableReason !== null) {
            if (reasonValue && comment) {
                setError("");
                const supplierNumbers = suppliers.map(item => item.supplierNumber)
                const putData = {
                    "criteriaId": criteriaId,
                    "supplierNumbers": supplierNumbers,
                    "reasonId": reasonValue,
                    "comments": comment
                }
                authAxios.put(`/ratingNA/${criteria.notApplicableReason.id}`, putData)
                    .then(res => {
                        onNotApplicableAction(res, "update")
                        enqueueToast({
                            variant: "success",
                            title: "Updated Successfully",
                            isCloseable: true
                        });
                    }).catch((error) => {
                    enqueueToast({
                        variant: "error",
                        title: "System Error",
                        message: error.response ? error.response.data[error.response.status] : "",
                        isPersistent: true
                    });
                    console.log(error);
                });
            } else {
                setError("Not applicable Reason and Comments are required")
            }
        } else {
            if(criteria.overrideReason){
                setError("Rating N/A can't be applied as override already added")
            }
            else if (reasonValue && comment) {
                setError("");
                const supplierNumbers = suppliers.map(item => item.supplierNumber)
                const postData = {
                    "criteriaId": criteriaId,
                    "supplierNumbers": supplierNumbers,
                    "reasonId": reasonValue,
                    "comments": comment
                }
                authAxios.post(`/ratingNA`, postData)
                    .then(res => {
                        onNotApplicableAction(res, "save")
                        enqueueToast({
                            variant: "success",
                            title: "Saved Successfully",
                            isCloseable: true
                        });
                    }).catch((error) => {
                    enqueueToast({
                        variant: "error",
                        title: "System Error",
                        message: error.response ? error.response.data[error.response.status] : "",
                        isPersistent: true
                    });
                    console.log(error);
                });
            } else {
                setError("Not applicable Reason and Comments are required")
            }
        }
    }

    const handleReasonChange = (event) => {
        setReasonValue(event.target.value);
    };

    useEffect(() => {
        const filteredData = reasons.filter(item => item.type === "notapplicable")
        setReasonsList(filteredData);

        return () => {
            setReasonsList([]);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (criteria.notApplicableReason !== null) {
            setComment(criteria.notApplicableReason.comments)
            setReasonValue(criteria.notApplicableReason.reasonId)
        }
    }, [criteria])

    return (
        <Grid container>
            <Grid item xs={4}>
                <Box p={2}>
                    <FormSelect
                        label={"Not Applicable Reason"}
                        defValue={reasonValue}
                        name={"Not Applicable Reason"}
                        options={reasonsList}
                        onTypeChange={handleReasonChange}
                        control={control}
                        isShowSelect={true}
                        required={true}
                        type={"overrideScore"}
                    />
                </Box>
            </Grid>
            <Grid item xs={8}>
                <Box p={2}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="reasonComment">Comments
                            <span style={{
                                marginLeft: ".25rem",
                                display: "inline"
                            }}
                                  aria-label="required field"
                                  className="uxf-is-required"
                            > * </span>
                        </InputLabel>
                        <Controller
                            rules={{required: true}}
                            control={control}
                            defaultValue={comment}
                            value={comment}
                            name={"reasonComment"}
                            render={({onChange, value}) => (
                                <Input fullWidth
                                       id="reasonComment"
                                       placeholder="Start Typing Comment..."
                                       value={comment}
                                       onChange={(e) => {
                                           onChange(e.target.value)
                                           setComment(e.target.value)
                                       }}
                                />
                            )}
                        />
                    </FormControl>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                    <FormHelperText error={error !== ""} style={{padding: ".5rem"}}>{error}</FormHelperText>
                    {isEdit &&
                    <ModalDialog
                        titleText={"Delete N/A Reason"}
                        content={<React.Fragment> Are you sure you want to delete the N/A Reason?</React.Fragment>}
                        saveButtonText={"Delete"}
                        onSave={onDelete}
                        page={"Ratings"}
                    />
                    }
                    <Button variant="secondary" style={{marginRight: ".5rem"}} size="medium" onClick={() => {
                        onCancel()
                    }}>Cancel</Button>
                    <Button variant="primary" size="medium" type="submit"
                            onClick={() => onSubmit()}
                    >Save</Button>
                </Box>
            </Grid>
        </Grid>
    )
}
